export default {
  parent_invoice: 'Invoice',
  parent_refund: 'Refund',
  parent_credit: 'Credit',
  parent_payment: 'Payment'
};
